import { IEntityDto } from "./base";

export interface IDefaultPriceMargin extends IEntityDto {
  fromAmount?: number;
  margin?: number;
}
